// clearance-results-svg.js

// Utility functions for rendering SVG views in the clearance results
// Updates the PLAN SVG Views

function getContainerMap(targetPrefix) {
   return {
      top: `#${targetPrefix}Top`,
      side: `#${targetPrefix}Side`,
      front: `#${targetPrefix}Front`,
   };
}

export function clearSvgViews(targetPrefix) {
   const containerMap = getContainerMap(targetPrefix);

   // Clear all matching containers
   Object.values(containerMap).forEach((selector) => {
      $(selector).empty();
   });
}
/**
 * Renders SVG views into the corresponding DOM containers using a prefix.
 *
 * @param {Array} svgSet - Array of { view: 'top'|'side'|'front', svg: '<svg>' }
 * @param {String} targetPrefix - DOM ID prefix for the container set, e.g. 'svgPlan' or 'svgIso'
 */
export function renderSvgViews(svgSet, targetPrefix) {
   if (svgSet == null || !Array.isArray(svgSet) || svgSet.length === 0) {
      return;
   }

   // Inject each available SVG #svgPlanTop, #svgPlanSide, #svgPlanFront etc
   // for each view in the svgSet.
   const containerMap = getContainerMap(targetPrefix);
   svgSet.forEach(({ view, svg }) => {
      const selector = containerMap[view];
      if (selector && svg) {
         $(selector).html(svg);
      }
   });
}
